/* eslint-disable react/jsx-props-no-spreading */
import { useTranslation } from 'react-i18next';
import CustomModalHeader from 'components/modal/customModalHeader';
import {HiOutlineCalendar, HiOutlineX} from 'react-icons/hi';
import useUser from 'hooks/useUser';
import { Modal } from 'flowbite-react';
import  { useEffect, useRef, useState } from 'react';
import { themModal } from 'utils/theme';
import '../../form/styles.scss';
import GroupButton from 'components/button/groupButton';
import { exportStockFormOrg } from 'api/stockApi';
import { useSelector } from 'react-redux';
import { locationSelector, orgSelector, userSelector } from 'redux/selectors';
import MultiSelect from 'components/select/index';
import { getCategoriesByFilter } from 'api/categoryApi';
import { pageType, permissionKeys, sortByTypeType, defaultpageCount } from 'utils/constants';
import { toast } from 'react-toastify';
import { checkOrgAdmin, checkPermission, getUserOrg } from 'utils/utils';
import { getLocationByFilter } from 'api/locationApi';
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/themes/material_blue.css'; // Import a Flatpickr theme

type exportStockModalProps = {
  openModal: boolean,
  setOpenModal: Function,
  headerTitle?: string
};
const ExportStockModal = (props: exportStockModalProps) => {
  const { openModal, setOpenModal, headerTitle } = props;
  const { fetchCurrentUser } = useUser();
  const [t] = useTranslation();
  const { userInfo } = useSelector(userSelector);
  const rootRef = useRef(null);
  const { organizationId } = useSelector(orgSelector);
  const { locationId } = useSelector(locationSelector);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [categoryTypeOptions, setCategoryTypeOptions] = useState([{ label: '...', value: '' }]);
  const [selectedItemCount, setSelectedItemCount] = useState([]);
  const [categoryIds, setCategoryIds] = useState('');
  const [itemCountOptions, setItemCountOptions] = useState([{ label: 'All', value: 'all' }, { label: 'Negative', value: 'negative' }, { label: 'Positive', value: 'positive' }]);
  const [itemCount, setItemCount] = useState('all');
  const [selectedType, setSelectedType] = useState<any>({label: 'This Location', value: "This"});
  const [typeOptions, setTypeOptions] = useState([
            {label: 'This Location', value: "This"},
            {label: 'All My Locations', value: "All"}
        ]);
  const {WRITE_LOCATION, PLATFORM_ADMIN} = permissionKeys;
  const isAdmin = checkPermission(userInfo, pageType.LOCATION, [PLATFORM_ADMIN], organizationId);
  const isOrgAdmin = checkOrgAdmin(userInfo, organizationId, isAdmin);
  const flatpickrRef = useRef<Flatpickr | null>(null);
  const [dateFilter, setDateFilter] = useState<any>([]);
  const [fDate, setFDate] = useState('');
  const [tDate, setTDate] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const pageCountDefault = 1000;
  const [errors, setErrors] = useState<any>({
    date: t('requiredField'),
    category: t('requiredField'),
    itemCount: t('requiredField'),
    location: ''
  });
      
    
  const getRegions = () => {
        const userOrg = userInfo?.organizations?.find((o: any) => o.id === organizationId);
        const orgRegions = userOrg?.regions;
        let regionIds = '';
        if (orgRegions) {
            for (let index = 0; index < orgRegions.length; index++) {
                const region = orgRegions[index];
                if (regionIds === '') {
                    regionIds = region.id;
                } else {
                    regionIds = `${regionIds},${region.id}`;
                }
            }
        }
        return regionIds;
    }

    const fetchCategories = async (page = 0, accumulatedData = []) => {
      try {
        const res = await getCategoriesByFilter({
          page,
          limit: pageCountDefault,
          sortByType: sortByTypeType.DESC,
          organizationId,
        });
  
        const totalCount = res?.data?.totalEntities || 0;
        const newData: any = [...accumulatedData, ...(res?.data?.entities || [])];
  
        if (totalCount === 0) {
          setCategoryTypeOptions([]);
          setTotalPages(0);
          return;
        }
  
        const pageBreak = Math.ceil(totalCount / pageCountDefault);
        setTotalPages(pageBreak);
  
        if (page < pageBreak - 1) {
          await fetchCategories(page + 1, newData);
        } else {
          const newOptions = newData.map((item: any) => ({
            label: item.name,
            value: item.id,
          }));
          setCategoryTypeOptions(newOptions);
        }
      } catch (error) {
        console.error('Error fetching categories:', error);
        setCategoryTypeOptions([]);
      } finally {
        
      }
    };

  useEffect(() => {
    fetchCategories();
      // eslint-disable-next-line
  }, []);

  const toggleHandler = () => {
    setOpenModal(!openModal);
  };

  const handleExportItem = async () => {
    if (errors.date !== '' || errors.category !== '' || errors.itemCount !== '' || errors.location !== '') {
      toast.error(`${t('uploadFile.exportError')}`);
      return;
    }

    setSelectedType(selectedType);
    setIsLoading(true);
    if (selectedType?.value === "This") {
      exportStockFormOrg(organizationId, {categoryIds, itemCount, locationId, fDate, tDate}).then(res => {
        if (res.data) {
          if (res.status === 200) {
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', `stock-on-hand-export.csv`);
              document.body.appendChild(link)
              link.click();

              // Remove dom after finish
              document.body.removeChild(link);
              setIsLoading(false);
          } else {
              if (res.status === 204) {
                  toast.error(`${t('uploadFile.noItemExport')}`);
                  setIsLoading(false);
              } else {
                  toast.error(`${t('uploadFile.exportError')}`);
                  setIsLoading(false);
              }
          }
        }
      })
      .catch(err => {
        toast.error(`${t('uploadFile.exportError')}`);
        setIsLoading(false);
      });
    } else {
      let ids = '';
      const resCount = await getLocationByFilter({ page: 0, limit: 5, sortByType: sortByTypeType.DESC, organizationId, userOrgId: isOrgAdmin === true ? null : getUserOrg(userInfo, organizationId)?.userOrganizationId, regionIds: isOrgAdmin === true ? '' : getRegions(), isActive: true });
      const totalCount  = resCount?.data?.totalEntities;
      const pageBreak = Math.ceil(totalCount / defaultpageCount);
      let listTemps: any = [];
      for (let index = 0; index < pageBreak; index++) {
          const resPage = await getLocationByFilter({ page: index, limit: defaultpageCount, sortByType: sortByTypeType.DESC, organizationId, userOrgId: isOrgAdmin === true ? null : getUserOrg(userInfo, organizationId)?.userOrganizationId, regionIds: isOrgAdmin === true ? '' : getRegions(), isActive: true });
          if (listTemps.length === 0) {
              listTemps = resPage?.data?.entities;
          } else {
              listTemps = listTemps.concat(resPage?.data?.entities);
          }
      }
      if (listTemps) {
        for (let index = 0; index < listTemps.length; index++) {
          const element = listTemps[index];
          if (ids === '') {
            ids = element.id;
          } else {
            ids = `${ids},${element.id}`;
          }
        }
      }
      exportStockFormOrg(organizationId, {categoryIds, itemCount, locationIds: ids, fDate, tDate}).then(res => {
        if (res.data) {
          if (res.status === 200) {
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', `stock-on-hand-export.csv`);
              document.body.appendChild(link)
              link.click();

              // Remove dom after finish
              document.body.removeChild(link);
              setIsLoading(false);
          } else {
              if (res.status === 204) {
                  toast.error(`${t('uploadFile.noItemExport')}`);
                  setIsLoading(false);
              } else {
                  toast.error(`${t('uploadFile.exportError')}`);
                  setIsLoading(false);
              }
          }
        }
        else {
          toast.error(`${t('uploadFile.exportError')}`);
          setIsLoading(false);
        }
      })
      .catch(err => {
        toast.error(`${t('uploadFile.exportError')}`);
        setIsLoading(false);
      });
    }
  };

  const handleChangeCategory = (option: any) => {
    setSelectedCategory(option);

    let cateIds = '';
    for (let index = 0; index < option?.length; index++) {
        const element = option[index];
        if (cateIds === '') {
            cateIds = element.value;
        } else {
            cateIds = `${cateIds},${element.value}`;
        }
    }
    setCategoryIds(cateIds);
    let err = errors;
    if (option?.length < 1) {
      err.category = t('requiredField');
      setErrors(err);
    }
    else {
      err.category = '';
      setErrors(err);
    }
  };

  const handleChangeItemCount = (option: any) => {
    setSelectedItemCount(option);
    setItemCount(option?.value);
    let err = errors;
    if (!option) {
      err.itemCount = t('requiredField');
      setErrors(err);
    }
    else {
      err.itemCount = '';
      setErrors(err);
    }
  };

  const handleChangeType = (option: any) => {
    setSelectedType(option);
    let err = errors;
    if (!option) {
      err.location = t('requiredField');
      setErrors(err);
    }
    else {
      err.location = '';
      setErrors(err);
    }
};

const handleChangeDate = (option: any) => {
  let err = errors;
  if (option) {
      err.date = '';
      setErrors(err);
      if (option[0]) {
        setTDate((option[0] as Date).toLocaleDateString());
      }

      setDateFilter(option);
  } else {
      err.date = t('requiredField');
      setErrors(err);
      setTDate('');
      setDateFilter([]);
  }
};

const handleClearSelection = () => {
  let err = errors;
  if (flatpickrRef.current) {
      flatpickrRef.current.flatpickr.clear();
      setTDate('');
      err.date = t('requiredField');
      setErrors(err);
  }
};

const customStyles = {
  menu: (provided: any) => ({
    ...provided,
    zIndex: 2,
  }),
  menuPortal: (provided: any) => ({
    ...provided,
    zIndex: 2,
  }),
};

  return (
    <div ref={rootRef} className="group-modal-container">
      <Modal
        show={openModal}
        size="2xl"
        className="group-modal"
        root={rootRef.current ?? undefined}
        onClose={toggleHandler}
        //dismissible={true}
        theme={themModal}
      >
        <CustomModalHeader title={headerTitle} toggle={toggleHandler} />
        <Modal.Body theme={{ base: 'flex-12 pb-4 pt-3 px-12' }}>
            <div className="custom-date-range-modal date-range48 mt-4 relative">
                            <Flatpickr
                                ref={flatpickrRef}
                                value={dateFilter}
                                onChange={(e: any) => handleChangeDate(e)}
                                options={
                                    {
                                        mode: 'single',
                                        dateFormat: 'M-d-Y'
                                    }
                                }
                                placeholder="Select Date"
                            />
                            {fDate !== '' && tDate !== '' ?
                                <button onClick={handleClearSelection}><HiOutlineX/></button> : <HiOutlineCalendar/>}
              </div>
              {errors?.date !== '' && <div className={`text-red-600 text-xs font-normal mt-1 veri-modal height-16`}>{errors?.date}</div>}
            <div className="mt-4 relative flex md:flex-row flex-col">
                <MultiSelect
                    onChange={handleChangeCategory}
                    options={categoryTypeOptions}
                    value={selectedCategory}
                    name="categoryId"
                    noOptionsMessage={() => t('No options')}
                    closeMenuOnSelect
                    isHolderLabel={true}
                    placeholder={`${t('sidebar.category')}`}
                    isMulti={true}
                    customStyles={customStyles}
                />
            </div>
            {errors?.category !== '' && <div className={`text-red-600 text-xs font-normal mt-1 veri-modal height-16`}>{errors?.category}</div>}
            <div className="mt-4 relative flex md:flex-row flex-col">
                <MultiSelect
                        onChange={handleChangeItemCount}
                        options={itemCountOptions}
                        value={selectedItemCount}
                        name="itemCount"
                        noOptionsMessage={() => t('No options')}
                        closeMenuOnSelect
                        isHolderLabel={true}
                        placeholder={`${t('stockPage.itemCount')}`}
                        customStyles={customStyles}
                    />
            </div>
            {errors?.itemCount !== '' && <div className={`text-red-600 text-xs font-normal mt-1 veri-modal height-16`}>{errors?.itemCount}</div>}
            <div className="mt-4 relative flex md:flex-row flex-col">
                <MultiSelect
                        onChange={handleChangeType}
                        options={typeOptions}
                        value={selectedType}
                        name="type"
                        noOptionsMessage={() => t('No options')}
                        closeMenuOnSelect
                        isHolderLabel={true}
                        placeholder={`${t('orderPage.location')}`}
                    />
            </div>
            {errors?.location !== '' && <div className={`text-red-600 text-xs font-normal mt-1 veri-modal height-16`}>{errors?.location}</div>}
            <GroupButton
              className="items-center justify-center pt-5 mb-4"
              buttons={[
                {
                  type: 'button',
                  text: t('modal.cancel'),
                  classType: 'white',
                  action: () => toggleHandler(),
                },
                {
                  type: 'button',
                  text: t('modal.export'),
                  classType: 'blue',
                  isLoading: isLoading,
                  action: () => handleExportItem(),
                },
              ]}
            />
        </Modal.Body>
      </Modal>
    </div>
  );
};
export default ExportStockModal;
